import React from 'react'
import { CircularProgress } from '@mui/material';
const LoadingCellFullPage = () => {
    return (
        <div className="bg-white d-flex align-items-center justify-content-center mt-2 mb-2 vh-100"><CircularProgress size={20} color='error' /></div>
    );
}

export default LoadingCellFullPage